import {
  GET_SYSTEM_WALLET_LIST,
  GET_SYSTEM_WALLET_LIST_SUCCESS,
  GET_SYSTEM_WALLET_LIST_FAILURE,
  GET_SYSTEM_WALLET_DATA,
  GET_SYSTEM_WALLET_DATA_SUCCESS,
  GET_SYSTEM_WALLET_DATA_FAILURE,
  UPDATE_SYSTEM_WALLET,
  UPDATE_SYSTEM_WALLET_SUCCESS,
  UPDATE_SYSTEM_WALLET_FAILURE,
  TOPUP_SYSTEM_WALLET,
  TOPUP_SYSTEM_WALLET_SUCCESS,
  TOPUP_SYSTEM_WALLET_FAILURE,
  GET_SYSTEM_WALLET_TRANSACTIONS,
  GET_SYSTEM_WALLET_TRANSACTIONS_SUCCESS,
  GET_SYSTEM_WALLET_TRANSACTIONS_FAILURE,
  ADJUST_SYSTEM_WALLET,
  ADJUST_SYSTEM_WALLET_SUCCESS,
  ADJUST_SYSTEM_WALLET_FAILURE,
  GET_MY_WALLET,
  GET_MY_WALLET_SUCCESS,
  GET_MY_WALLET_FAILURE,
  GET_MY_WALLET_TRANSACTIONS,
  GET_MY_WALLET_TRANSACTIONS_SUCCESS,
  GET_MY_WALLET_TRANSACTIONS_FAILURE,
  TOPUP_MY_WALLET,
  TOPUP_MY_WALLET_SUCCESS,
  TOPUP_MY_WALLET_FAILURE,
  UPDATE_MY_WALLET,
  UPDATE_MY_WALLET_SUCCESS,
  UPDATE_MY_WALLET_FAILURE,
  GET_SYSTEM_WALLET_SERVICE_TYPE_LIST,
  GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_SUCCESS,
  GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_FAILURE,
  CREATE_SYSTEM_WALLET_SERVICE_TYPE,
  CREATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS,
  CREATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE,
  UPDATE_SYSTEM_WALLET_SERVICE_TYPE,
  UPDATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS,
  UPDATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE,
  DELETE_SYSTEM_WALLET_SERVICE_TYPE,
  DELETE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS,
  DELETE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE,
  GET_SYSTEM_WALLET_SERVICE_RATE_LIST,
  GET_SYSTEM_WALLET_SERVICE_RATE_LIST_SUCCESS,
  GET_SYSTEM_WALLET_SERVICE_RATE_LIST_FAILURE,
  CREATE_SYSTEM_WALLET_SERVICE_RATE,
  CREATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS,
  CREATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE,
  UPDATE_SYSTEM_WALLET_SERVICE_RATE,
  UPDATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS,
  UPDATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE,
  DELETE_SYSTEM_WALLET_SERVICE_RATE,
  DELETE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS,
  DELETE_SYSTEM_WALLET_SERVICE_RATE_FAILURE,
  SYSTEM_WALLET_RESET_RESPONSE,
} from "./actionType";

// ***** Wallet list *****
export const getSystemWalletList = () => ({ type: GET_SYSTEM_WALLET_LIST });
export const getSystemWalletListSuccess = (data) => ({
  type: GET_SYSTEM_WALLET_LIST_SUCCESS,
  payload: data,
});
export const getSystemWalletListFailure = (error) => ({
  type: GET_SYSTEM_WALLET_LIST_FAILURE,
  payload: error,
});

// ***** Single wallet *****
export const getSystemWalletData = (Company_Id) => ({
  type: GET_SYSTEM_WALLET_DATA,
  payload: Company_Id,
});
export const getSystemWalletDataSuccess = (data) => ({
  type: GET_SYSTEM_WALLET_DATA_SUCCESS,
  payload: data,
});
export const getSystemWalletDataFailure = (error) => ({
  type: GET_SYSTEM_WALLET_DATA_FAILURE,
  payload: error,
});

// ***** Update wallet settings *****
export const updateSystemWallet = (data) => ({
  type: UPDATE_SYSTEM_WALLET,
  payload: data,
});
export const updateSystemWalletSuccess = (data) => ({
  type: UPDATE_SYSTEM_WALLET_SUCCESS,
  payload: data,
});
export const updateSystemWalletFailure = (error) => ({
  type: UPDATE_SYSTEM_WALLET_FAILURE,
  payload: error,
});

// ***** Manual top-up *****
export const topUpSystemWallet = (data) => ({
  type: TOPUP_SYSTEM_WALLET,
  payload: data,
});
export const topUpSystemWalletSuccess = (data) => ({
  type: TOPUP_SYSTEM_WALLET_SUCCESS,
  payload: data,
});
export const topUpSystemWalletFailure = (error) => ({
  type: TOPUP_SYSTEM_WALLET_FAILURE,
  payload: error,
});

// ***** Transactions (ledger) *****
export const getSystemWalletTransactions = (Company_Id) => ({
  type: GET_SYSTEM_WALLET_TRANSACTIONS,
  payload: Company_Id,
});
export const getSystemWalletTransactionsSuccess = (data) => ({
  type: GET_SYSTEM_WALLET_TRANSACTIONS_SUCCESS,
  payload: data,
});
export const getSystemWalletTransactionsFailure = (error) => ({
  type: GET_SYSTEM_WALLET_TRANSACTIONS_FAILURE,
  payload: error,
});

// ***** Manual adjust *****
export const adjustSystemWallet = (data) => ({
  type: ADJUST_SYSTEM_WALLET,
  payload: data,
});
export const adjustSystemWalletSuccess = (data) => ({
  type: ADJUST_SYSTEM_WALLET_SUCCESS,
  payload: data,
});
export const adjustSystemWalletFailure = (error) => ({
  type: ADJUST_SYSTEM_WALLET_FAILURE,
  payload: error,
});

// ***** Customer-facing own wallet (Company_Id resolved from the token) *****
export const getMyWallet = () => ({ type: GET_MY_WALLET });
export const getMyWalletSuccess = (data) => ({
  type: GET_MY_WALLET_SUCCESS,
  payload: data,
});
export const getMyWalletFailure = (error) => ({
  type: GET_MY_WALLET_FAILURE,
  payload: error,
});

export const getMyWalletTransactions = () => ({
  type: GET_MY_WALLET_TRANSACTIONS,
});
export const getMyWalletTransactionsSuccess = (data) => ({
  type: GET_MY_WALLET_TRANSACTIONS_SUCCESS,
  payload: data,
});
export const getMyWalletTransactionsFailure = (error) => ({
  type: GET_MY_WALLET_TRANSACTIONS_FAILURE,
  payload: error,
});

export const topUpMyWallet = (data) => ({
  type: TOPUP_MY_WALLET,
  payload: data,
});
export const topUpMyWalletSuccess = (data) => ({
  type: TOPUP_MY_WALLET_SUCCESS,
  payload: data,
});
export const topUpMyWalletFailure = (error) => ({
  type: TOPUP_MY_WALLET_FAILURE,
  payload: error,
});

export const updateMyWallet = (data) => ({
  type: UPDATE_MY_WALLET,
  payload: data,
});
export const updateMyWalletSuccess = (data) => ({
  type: UPDATE_MY_WALLET_SUCCESS,
  payload: data,
});
export const updateMyWalletFailure = (error) => ({
  type: UPDATE_MY_WALLET_FAILURE,
  payload: error,
});

// ***** Service types (CRUD) *****
export const getSystemWalletServiceTypeList = () => ({
  type: GET_SYSTEM_WALLET_SERVICE_TYPE_LIST,
});
export const getSystemWalletServiceTypeListSuccess = (data) => ({
  type: GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_SUCCESS,
  payload: data,
});
export const getSystemWalletServiceTypeListFailure = (error) => ({
  type: GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_FAILURE,
  payload: error,
});

export const createSystemWalletServiceType = (data) => ({
  type: CREATE_SYSTEM_WALLET_SERVICE_TYPE,
  payload: data,
});
export const createSystemWalletServiceTypeSuccess = (data) => ({
  type: CREATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS,
  payload: data,
});
export const createSystemWalletServiceTypeFailure = (error) => ({
  type: CREATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE,
  payload: error,
});

export const updateSystemWalletServiceType = (data) => ({
  type: UPDATE_SYSTEM_WALLET_SERVICE_TYPE,
  payload: data,
});
export const updateSystemWalletServiceTypeSuccess = (data) => ({
  type: UPDATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS,
  payload: data,
});
export const updateSystemWalletServiceTypeFailure = (error) => ({
  type: UPDATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE,
  payload: error,
});

export const deleteSystemWalletServiceType = (data) => ({
  type: DELETE_SYSTEM_WALLET_SERVICE_TYPE,
  payload: data,
});
export const deleteSystemWalletServiceTypeSuccess = (data) => ({
  type: DELETE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS,
  payload: data,
});
export const deleteSystemWalletServiceTypeFailure = (error) => ({
  type: DELETE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE,
  payload: error,
});

// ***** Service rates (CRUD) *****
export const getSystemWalletServiceRateList = () => ({
  type: GET_SYSTEM_WALLET_SERVICE_RATE_LIST,
});
export const getSystemWalletServiceRateListSuccess = (data) => ({
  type: GET_SYSTEM_WALLET_SERVICE_RATE_LIST_SUCCESS,
  payload: data,
});
export const getSystemWalletServiceRateListFailure = (error) => ({
  type: GET_SYSTEM_WALLET_SERVICE_RATE_LIST_FAILURE,
  payload: error,
});

export const createSystemWalletServiceRate = (data) => ({
  type: CREATE_SYSTEM_WALLET_SERVICE_RATE,
  payload: data,
});
export const createSystemWalletServiceRateSuccess = (data) => ({
  type: CREATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS,
  payload: data,
});
export const createSystemWalletServiceRateFailure = (error) => ({
  type: CREATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE,
  payload: error,
});

export const updateSystemWalletServiceRate = (data) => ({
  type: UPDATE_SYSTEM_WALLET_SERVICE_RATE,
  payload: data,
});
export const updateSystemWalletServiceRateSuccess = (data) => ({
  type: UPDATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS,
  payload: data,
});
export const updateSystemWalletServiceRateFailure = (error) => ({
  type: UPDATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE,
  payload: error,
});

export const deleteSystemWalletServiceRate = (data) => ({
  type: DELETE_SYSTEM_WALLET_SERVICE_RATE,
  payload: data,
});
export const deleteSystemWalletServiceRateSuccess = (data) => ({
  type: DELETE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS,
  payload: data,
});
export const deleteSystemWalletServiceRateFailure = (error) => ({
  type: DELETE_SYSTEM_WALLET_SERVICE_RATE_FAILURE,
  payload: error,
});

// ***** Reset transient responses *****
export const systemWalletResetResponse = (keys) => ({
  type: SYSTEM_WALLET_RESET_RESPONSE,
  payload: keys,
});
